module.exports = __webpack_public_path__ + "img/oliver-c.8c0603b1.png";